import Financial from "../pages/financial/Financial";

function FinancialRoutes() {
    return [{ path: "/financial", element: <Financial /> }];
}

export default FinancialRoutes;
